export var boxShadow = function(param) {
    var xOffset = param.xOffset, yOffset = param.yOffset, blurRadius = param.blurRadius, spreadRadius = param.spreadRadius, color = param.color;
    return "".concat(xOffset, " ").concat(yOffset, " ").concat(blurRadius, " ").concat(spreadRadius, " ").concat(color);
};
export default boxShadow;
